<form #contactFormElement [formGroup]="addressForm" id="addressStage">
  <div class="row">
    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'country' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'never'" appearance="outline" class="select">
        <mat-select (selectionChange)="onAddressCountryChanged()"
                    formControlName="addressCountry"
                    name="addresscountry">
          <mat-select-trigger>
            <span *ngIf="getCountryCode(addressModel.countryName)" class="ml-auto">
<!--              <img src="/img/flags/{{getCountryCode(addressModel.countryName)}}.png"-->
              <!--                   [default]="'/img/flags/undefined.png'" class="small-flag-icon">-->
            </span>
            <span class="country-info"> {{ getTranslate(addressModel.countryName) }}</span>
          </mat-select-trigger>
          <mat-select-search #addresscountrySearch></mat-select-search>
          <mat-option *ngFor=" let country of filterCountryList(countryList, addresscountrySearch.filter, false)"
                      value="{{country.countryName}}">
            <!--            <img src="/img/flags/{{country.countryCode}}.png" [default]="'/img/flags/undefined.png'" class="flag-icon">-->
            <span class="country-info">{{ country.countryTranslation }}</span>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredField('addressCountry')">
          {{ 'countryRequired' | translate }}
        </mat-error>
      </mat-form-field>

      <div class="error-container">
        <div *ngIf="isEUCountryWithUSMonitoring()" class="error">
          {{ 'EUCountryWithUSMonitoring' | translate }}
        </div>
      </div>
    </section>

    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'city' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'never'" appearance="outline">
        <input class="ltr-text" formControlName="addressCity" matInput maxlength="100"
               name="city"
               oninput="this.value=this.value.replace(/[^a-zA-Z|-\s]/g,'')"
               onkeypress="return String.fromCharCode(event.keyCode).match(/\p{L}|-| /u)?true:false">

        <mat-error *ngIf="isRequiredField('addressCity')">
          {{ 'cityRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <div class="w-lg-100"></div>

    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'address' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'never'" appearance="outline">
        <input class="ltr-text" formControlName="address1" matInput maxlength="200"
               name="address1" oninput="this.value=this.value.replace(/[^a-zA-Z0-9|-\s]/g,'')">

        <mat-error *ngIf="isRequiredField('address1')">
          {{ 'addressRequired' | translate }}
        </mat-error>

        <mat-error *ngIf="hasErrorField('address1', 'poBox')">
          {{ 'addressInvalid' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'address2' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline">
        <input formControlName="address2" matInput maxlength="200"
               name="address2" oninput="this.value=this.value.replace(/[^a-zA-Z0-9|-\s]/g,'')">

        <mat-error *ngIf="isRequiredField('address2')">
          {{ 'address2Required' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'postalCode' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline">
        <input formControlName="addressPostalCode" matInput maxlength="20"
               name="postalcode" oninput="this.value=this.value.replace(/[^A-Za-z0-9_ ]/g,'')">
        <mat-error *ngIf="isRequiredField('addressPostalCode')">
          {{ 'addressPostalCode' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <section [ngClass]="{'d-none': addressModel.countryName === 'Israel'}" class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'state' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field appearance="outline" class="select" class="info">
        <mat-select (selectionChange)="updateUser()" disableOptionCentering
                    formControlName="addressState" name="state">
          <mat-select-trigger>
        <span class="country-info">
          {{ getStateName(addressModel.countryName, addressModel.state) }}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let state of getStatesByCountry(addressModel.countryName)" value="{{state.code}}">
            <span class="country-info">{{ state.name }}</span>
          </mat-option>
        </mat-select>

        <mat-error *ngIf="isRequiredField('addressState')">
          {{ 'stateRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>
  </div>
</form>
